// GuideEditorPage.js
import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useExperiences } from "../context/ExperiencesContext";
import GuideEditor from "../components/GuideEditor";
import { Box, CircularProgress } from "@mui/material";
import ExperiencesApi from "../services/ExperiencesAPI";


// Helper to generate a new UUID
const generateId = () => crypto.randomUUID();

const GuideEditorPage = () => {
  const { guideId } = useParams();
  const [searchParams] = useSearchParams();
  const { guides } = useExperiences();
  const [guide, setGuide] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cloned, setCloned] = useState(false)

  useEffect(() => {
   
    if (guideId === "new") {
      console.log("CLONING")
      const cloneFrom = searchParams.get("cloneFrom");
      if (cloneFrom) {
        ExperiencesApi.get(`guides/${cloneFrom}`, { requiresAuth: true })
          .then((response) => {
            const guideData = response.data;
             const newGuideId = generateId();
            // Clone and update all insightDatas:
            const clonedInsights = cloneInsightData(
              guideData.insightDatas || []
            );
            // Create the new guide object with a new id and a modified name.
            setGuide({
              ...guideData,
              id: newGuideId, // new guide id
              name: guideData.name + " (Clone)",
              insightDatas: clonedInsights,
              insightDataIds: clonedInsights.map((insight) => insight.id),
            });
            setLoading(false);
            setCloned(true)
          })
          .catch((error) => {
            console.error("Error fetching guide for clone", error);
            setLoading(false);
          });
      } else {
        setGuide({
          name: "New Guide",
          id: generateId(),
          insightDatas: [],
          insightDataIds: [],
        });
        setLoading(false);
        setCloned(true)
      }
    } else {
      // guideId was extracted from the sk, so use it directly to query the full guide JSON
      console.log("DO NORMAL GUIDE")
      ExperiencesApi.get(`guides/${guideId}`, { requiresAuth: true })
        .then((response) => {
          setGuide(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching guide", error);
          setLoading(false);
        });
    }
  }, [guideId, guides, searchParams]);

  useEffect(() => {
    console.log("GUIDE", guide)
  }, [guide])


  if (loading || !guide) {
    return <CircularProgress />;
  }

  return (
    <Box sx={{ padding: 2 }}>
      { !((guideId === "new") && !cloned) && <GuideEditor key={guide.id} initialGuide={guide} />}
    </Box>
  );
};


const cloneInsightData = (insightDatas) => {
  const idMapping = {};
  const isWrapped = insightDatas.length && insightDatas[0]?.data; // detect if already wrapped

  // Normalize to plain objects first
  const plain = isWrapped ? insightDatas.map(i => i.data) : insightDatas;

  const clonedPlain = plain.map((insight) => {
    const newId = generateId();
    idMapping[insight.id] = newId;
    return { ...insight, id: newId };
  });

  const updated = clonedPlain.map((insight, idx, arr) => {
    const prevInsightId = idx > 0 ? arr[idx - 1].id : null;

    const updatedTriggers = Array.isArray(insight.insightTriggers)
      ? insight.insightTriggers.map((trigger, i) => {
          const t = { ...trigger };
          if (t.triggerId) t.triggerId = idMapping[t.triggerId] ?? t.triggerId;
          if (i === 0 && t.insightTriggerType === 2 && prevInsightId) {
            t.triggerId = prevInsightId;
            t.name = arr[idx - 1]?.name || t.name;
          }
          return t;
        })
      : insight.insightTriggers;

    const remapConds = (conds) =>
      Array.isArray(conds)
        ? conds.map((c) => ({
            ...c,
            conditions: Array.isArray(c.conditions)
              ? c.conditions.map((x) => idMapping[x] ?? x)
              : c.conditions,
          }))
        : conds;

    return {
      ...insight,
      insightTriggers: updatedTriggers,
      startConditions: remapConds(insight.startConditions),
      endConditions: remapConds(insight.endConditions),
    };
  });

  // Re-wrap only if the input was wrapped
  return isWrapped ? updated.map(i => ({ data: i })) : updated;
};




export default GuideEditorPage;